var React = require('react');

function ArrowL (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0,7.5A2.72,2.72,0,0,1,1.17,5.29L8,.22A1.53,1.53,0,0,1,8.59,0a1,1,0,0,1,.85.44A1.21,1.21,0,0,1,9.23,2L3.39,6.4H79.11V8.6H3.5L9.33,13a1.22,1.22,0,0,1,.21,1.55,1.11,1.11,0,0,1-1.48.22L1.27,9.6A3.22,3.22,0,0,1,0,7.5Z","transform":"translate(0 0)","className":"fill-current"}));
}

ArrowL.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 79.11 14.97"};

module.exports = ArrowL;

ArrowL.default = ArrowL;
